import React from 'react';

export const PhotosIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20" {...props}>
        <path
            fill="currentColor"
            d="M9.092 0a.908.908 0 00-.765.47L7.14 2.84H2.55A2.57 2.57 0 000 5.391v11.37a2.57 2.57 0 002.55 2.55h19.892a2.57 2.57 0 002.55-2.55V5.395a2.571 2.571 0 00-2.55-2.55h-4.59L16.66.474a.872.872 0 00-.765-.469L9.092 0zm.53 1.704h5.753l1.202 2.376a.872.872 0 00.765.47h5.1a.834.834 0 01.852.851v11.36a.831.831 0 01-.852.851H2.55a.835.835 0 01-.854-.852V5.396a.834.834 0 01.854-.851h5.1a.872.872 0 00.766-.47l1.206-2.371zm2.874 3.692a5.399 5.399 0 105.402 5.4 5.412 5.412 0 00-5.402-5.4zm0 1.706a3.693 3.693 0 11-3.69 3.693 3.68 3.68 0 013.69-3.693z"
        />
    </svg>
);
